module.exports = __webpack_public_path__ + "static/img/Ben-Hunt.1f13a21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben-Hunt.jpg
// module id = PQyI
// module chunks = 0